import {Link} from "react-router-dom";
import React from "react";
import Button from "./Button";
import {Chip} from "@mui/material";

function StudyBar(){

    const customStyle = {
        border: "1px solid white",
        textAlign: "center",
        background: "#100720",
        color: "white"
    }

    return(
        <div  style={{display :"inline-flex",justifyContent:"space-around", width:"100%"}}>
            <Link to ="/whyjavascript">
                <Chip label="Javascript" variant="outlined" className="Lecture" style={customStyle }/>
            </Link>{''}

            <Link to="/javascripttutorials">
                <Chip label=" Tutorials" variant="outlined" className="Lecture" style={customStyle }/>
            </Link>{''}

        </div>
    )
}

export default StudyBar;
